import OrdersList from "./OrdersList";

export default function MyReviews() {
  return <OrdersList heading="My Reviews" subtitle="Everything you've booked. Open a review to view its workspace." />;
}
